<template>
    <!-- 右边信息 -->
    <div class="userCenter_right" v-loading="loading">
        <h4>个人信息认证</h4>
        <div class="steps_top">
            <el-steps :active="active" align-center>
                <el-step description="提交认证信息"></el-step>
                <el-step :class="status && status === 'REJECT' ? 'certificationErrorLine' : ''"
                    description="认证信息审核"></el-step>
                <el-step :class="status && status === 'REJECT' ? 'certificationError' : ''"
                    :description="status && status === 'REJECT' ? '认证失败' : '完成认证'"></el-step>
            </el-steps>
        </div>
        <!--认证状态-->
        <div class="certificationStatus" v-show="status && status !== 'APPROVE'">
            <img :src="status === 'SUBMIT' ? require('@/assets/auditIng.png') : require('@/assets/auditError.png')" alt="">
            <div class="name">{{ status === 'SUBMIT' ? '实名认证审核中' : '您的实名认证审核未通过' }}</div>
            <div class="message" v-if="status === 'SUBMIT'">请耐心等待审核结果（最长<span>3个工作日</span>）内完成审核</div>
            <div class="message" v-else>原因：{{ remark }}</div>
        </div>
        <img class="enterpriseCertificationSuccess" v-show="status && status === 'APPROVE'"
            src="@/assets/authenticationSuccess.png" alt="">

        <!-- 身份证 -->
        <div class="right_idcar flex"
            v-if="status !== 'SUBMIT' && (!status || status === 'REJECT' || status == 'APPROVE')">
            <div class="right_imgbox">
                <el-upload action="/service-center/api/v1/upload/file/single" :on-success="handleAvatarSuccess"
                    class="hiddenInput" :headers="headers" :before-upload="beforeAvatarUpload"
                    :disabled="status === 'SUBMIT'" :show-file-list="false">
                    <img v-if="!backUrl" :src="userInfo.avatar" alt="" />
                    <img v-if="backUrl" :src="backUrl" alt="" />
                </el-upload>
            </div>
            <div class="right_imgbox">
                <el-upload action="/service-center/api/v1/upload/file/single" :before-upload="beforeAvatarUpload"
                    :headers="headers" :on-success="handleAvatarSuccess2" class="hiddenInput2"
                    :disabled="status === 'SUBMIT'" :show-file-list="false">
                    <img v-if="!frontUrl" :src="userInfo2.avatar" alt="" />
                    <img v-if="frontUrl" :src="frontUrl" alt="" />
                </el-upload>
            </div>
        </div>
        <div style="padding: 20px 0 0 100px" v-if="status !== 'SUBMIT'">
            <div class="certiTop flex">
                <div class="flex certiTop_name">
                    <p>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</p>
                    <input type="text" v-model="name" placeholder="请输入姓名" :disabled="status === 'SUBMIT'" />
                </div>
                <div class="flex certiTop_name">
                    <p>性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别</p>
                    <span v-for="(items, index) in genderList" :key="index"
                        :class="genderIndex == index ? 'span_active' : ''" @click="getGender(index)">{{ items.gender
                        }}</span>
                </div>
            </div>
            <div class="certiTop_ID flex">
                <p>证件号码</p>
                <input type="text" v-model="cardNumValue" placeholder="请输入正确的证件号码" :disabled="status === 'SUBMIT'" />
            </div>
        </div>

        <div class="cardMess" v-else>
            <h5>您的认证信息</h5>
            <div class="cardMess_box">
                <div class="box_oitem">
                    <div class="oitem_title">身份证:</div>
                    <div class="oitem_img">
                        <el-image :src="backUrl" :preview-src-list="srcList">
                        </el-image>
                        <div class="oitem_img_text">
                            <i class="el-icon-view"></i>
                            <p>预览</p>
                        </div>
                    </div>
                    <div class="oitem_img">
                        <el-image :src="frontUrl" :preview-src-list="srcList">
                        </el-image>
                        <div class="oitem_img_text">
                            <i class="el-icon-view"></i>
                            <p>预览</p>
                        </div>
                    </div>
                </div>
                <div class="box_oitem">
                    <div class="oitem_title">性别:</div>
                    <span v-for="(items, index) in genderList" :key="index"
                        :class="genderIndex == index ? 'span_active' : ''" @click="getGender(index)">{{ items.gender
                        }}</span>
                </div>
            </div>
            <div class="cardMess_box">
                <div class="box_oitem">
                    <div class="oitem_title" style="width: 125px;">姓名:</div>
                    <el-input v-model="name" placeholder="请输入姓名" :disabled="status === 'SUBMIT'"></el-input>
                </div>
                <div class="box_oitem">
                    <div class="oitem_title" style="width: 125px;">证件号码:</div>
                    <el-input v-model="cardNumValue" placeholder="请输入正确的证件号码"
                        :disabled="status === 'SUBMIT'"></el-input>
                </div>
            </div>
        </div>

        <!-- 审核中和完成认证 -->
        <!-- <div class="right_idcar flex" v-show="status && status === 'APPROVE'">
            <div class="right_imgbox">
                <img v-if="!backUrl" :src="userInfo.avatar" alt=""/>
                <img v-if="backUrl" :src="backUrl" alt=""/>
            </div>
            <div class="right_imgbox">
                 <img v-if="!frontUrl" :src="userInfo2.avatar" alt=""/>
                 <img v-if="frontUrl" :src="frontUrl" alt=""/>
            </div>
        </div> -->
        <!-- <div style="padding: 20px 0 0 100px">
            <div class="certiTop flex">
                <div class="flex certiTop_name">
                    <p>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</p>
                    <span>{{name}}</span>
                </div>
                <div class="flex certiTop_name">
                    <p>性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别</p>
                    <span
                        v-for="(items, index) in genderList"
                        :key="index"
                        :class="genderIndex == index ? 'span_active' : ''"

                    >{{ items.gender }}</span
                    >
                </div>
            </div>
            <div class="certiTop_ID flex">
                <p>证件号码</p>
                <span>{{cardNumValue}}</span>
            </div>
        </div> -->
        <div class="certibutton">
            <!--<p v-show="status" :class="status === 'SUBMIT'?'tipClass tipClassWait':status === 'APPROVE'?'tipClass tipClassSuccess':'tipClass tipClassError'">-->
            <!--{{status === 'SUBMIT'?'正在认证审核中':status === 'APPROVE'?'认证成功':'认证失败'}}-->
            <!--<i :class="status === 'SUBMIT'?'el-icon-refresh-right':status === 'APPROVE'?'el-icon-circle-check':'el-icon-circle-close'"></i>-->
            <!--</p>-->
            <button @click="submit()" v-show="status !== 'SUBMIT'">{{ !status ? '提交' : status ===
                'APPROVE'?'修改认证信息':'认证提交'}}
            </button>
        </div>
    </div>
</template>

<script>
import { getCredentials, submitCredentials, amendCredentials, getIdCardInformation } from "../../../utils/interface";

export default {
    //   实名认证
    name: "CertificationCenter",
    data() {
        return {
            loading: false,
            active: 1,
            // 认证状态
            status: '',
            uuid: '',
            headers: {
                'Authorization': 'Bearer ' + this.$cookies.get("api_access_token")	//	可以是授权凭证用的参数值
            },
            genderList: [
                {
                    gender: "男",
                },
                {
                    gender: "女",
                },
            ],
            genderIndex: 0,
            // 上传身份证
            userInfo: {
                avatar: require("../../../assets/idCarP.png"),
            },
            userInfo2: {
                avatar: require("../../../assets/idCarC.png"),
            },
            backUrl: '',
            frontUrl: '',
            // 姓名
            name: '',
            // 身份证号
            cardNumValue: '',
            remark: ''
        };
    },
    computed: {
        srcList() {
            return [this.backUrl, this.frontUrl]
        },
    },
    methods: {
        getGender(i) {
            if (this.status !== 'SUBMIT') {
                this.genderIndex = i;
            }
        },
        // 将头像显示
        handleFile(e) {
            //获取当前点击事件的target元素对其进行兼容
            let $target = e.target || e.srcElement;
            //   取第一个元素
            let file = $target.files[0];
            /**
             * 使用FileReader对象，
             * web应用程序可以异步的读取存储在用户计算机上的文件(或者原始数据缓冲)内容，
             * 可以使用File对象或者Blob对象来指定所要处理的文件或数据。
             *  */
            var reader = new FileReader(); // //读取本地文件，以gbk编码方式输出
            reader.onload = (data) => {
                //成功读取后
                // console.log(data);
                let res = data.target || data.srcElement;
                // //读取完毕后输出结果
                this.userInfo.avatar = res.result;
            };
            reader.readAsDataURL(file);
        },
        beforeAvatarUpload(file) {
            let fileTypes = ['.jpg', '.png', '.jpeg', '.bmp', '.JPG', '.PNG', '.JPEG', '.BMP']
            let fileName = file.name.lastIndexOf('.')
            const fileNameLen = file.name.length
            const fileTypeName = file.name.substring(fileName, fileNameLen)
            let fileIndex = fileTypes.indexOf(fileTypeName)
            if (fileIndex === -1) {
                this.$alert("只能上传图片格式", "提示", {
                    confirmButtonText: "确定",
                })
            }
            return fileIndex !== -1
        },
        handleAvatarSuccess(obj, fileList) {
            let data = {
                url: obj.url
            }
            this.loading = true
            getIdCardInformation(data).then((res) => {
                this.loading = false
                if (res.success) {
                    this.backUrl = obj.url
                    this.cardNumValue = res.data.cardNum
                    this.name = res.data.name
                    this.genderIndex = res.data.gender === 'FEMALE' ? 1 : 0
                } else {
                    this.$alert('照片无法识别，请重新上传！', "提示", {
                        confirmButtonText: "确定",
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        handleAvatarSuccess2(obj, fileList) {
            this.frontUrl = obj.url
        },
        // 根据用户获取认证信息
        getUserCredentials() {
            this.loading = true
            getCredentials().then((res) => {
                this.loading = false
                if (res.success) {
                    this.status = res.data.status
                    this.uuid = res.data.uuid
                    this.backUrl = res.data.backUrl
                    this.cardNumValue = res.data.cardNum
                    this.frontUrl = res.data.frontUrl
                    this.name = res.data.name
                    this.remark = res.data.remark
                    this.genderIndex = res.data.gender === 'FEMALE' ? 1 : 0
                    if (this.status === 'SUBMIT') {
                        this.active = 2
                    } else {
                        this.active = 3
                    }
                } else {
                    this.status = ''
                    this.active = 1
                    this.uuid = ''
                    this.backUrl = ''
                    this.cardNumValue = ''
                    this.frontUrl = ''
                    this.name = ''
                    this.genderIndex = 0
                }
            }).catch(() => {
                this.loading = false
                this.status = ''
                this.active = 1
            })
        },
        // 提交
        submit() {
            if (!this.backUrl) {
                this.$alert("身份证人像面不能为空", "提示", {
                    confirmButtonText: "确定",
                })
                return false
            } else if (!this.frontUrl) {
                this.$alert("身份证国徽面不能为空", "提示", {
                    confirmButtonText: "确定",
                })
                return false
            } else if (!this.name) {
                this.$alert("姓名不能为空", "提示", {
                    confirmButtonText: "确定",
                })
                return false
            } else if (!this.cardNumValue) {
                this.$alert("证件号码不能为空", "提示", {
                    confirmButtonText: "确定",
                })
                return false
            } else if (!this.validate.isCardId(this.cardNumValue)) {
                this.$alert("请输入正确的证件号码", "提示", {
                    confirmButtonText: "确定",
                })
                return false
            } else {
                let data = {
                    backUrl: this.backUrl,
                    cardNum: this.cardNumValue,
                    frontUrl: this.frontUrl,
                    name: this.name,
                    gender: this.genderIndex === 0 ? 'MALE' : this.genderIndex === 1 ? 'FEMALE' : 'NONE'
                }
                this.loading = true
                if (!this.status) {
                    submitCredentials(data).then((res) => {
                        this.loading = false
                        if (res.success) {
                            this.$alert(res.message, "提示", {
                                confirmButtonText: "确定",
                            })
                            this.getUserCredentials()
                        }
                    }).catch(() => {
                        this.loading = false
                    })
                } else {
                    this.$set(data, 'uuid', this.uuid)
                    amendCredentials(data, this.uuid).then((res) => {
                        this.loading = false
                        if (res.success) {
                            this.$alert(res.message, "提示", {
                                confirmButtonText: "确定",
                            })
                            this.getUserCredentials()
                        } else {
                            this.$alert('提交失败！', "提示", {
                                confirmButtonText: "确定",
                            })
                        }
                    }).catch(() => {
                        this.loading = false
                    })
                }
            }
        }
    },
};
</script>

<style scoped lang="less">
/deep/ .el-step__head.is-finish {
    color: #2d50a1;
    border-color: #2d50a1;
}
/deep/ .el-step__description.is-finish {
    color: #2d50a1;
}

.blue {
    color: #2d50a1;
}

.red {
    color: #d60000;
}

.tipClass {
    margin-left: 18px;
    height: 45px;
    box-sizing: border-box;
    border-radius: 10px;
    line-height: 45px;
    text-align: center;
    background: #e2efff;
    padding: 0 20px;
    width: max-content;
    font-size: 14px;
    font-weight: bold;

    i {
        font-size: 16px;
        font-weight: bold;
    }
}

.tipClassSuccess {
    color: #00b11d;
    background: #d6f3d7;
}

.tipClassError {
    color: #ff8000;
    background: #ffd6ae;
}

.tipClassWait {
    color: #2d50a1;
    background: #e2efff;
}

.enterpriseCertificationSuccess {
    position: absolute;
    right: -29px;
    top: 54px;
    width: 200px;
    height: 200px
}

.certificationErrorLine {
    /deep/.el-step__head.is-finish {
        .el-step__line {
            border-color: #f66f6a !important;
        }
    }
}

.certificationError {
    /deep/.el-step__head.is-finish {
        color: #f66f6a;
        border-color: #f66f6a !important;
    }

    /deep/.el-step__description.is-finish {
        color: #f66f6a;
    }
}

.userCenter_right {
    width: 966px;
    background: #fff;
    position: relative;

    h4 {
        // color: #2d50a1;
        padding: 20px 18px;
        border-bottom: 2px solid #f9f9f9;
    }

    .steps_top {
        padding: 20px 18px;

        /deep/ .el-step.is-center .el-step__description {
            margin-top: 10px;
        }

        /deep/ .el-step__icon {
            width: 35px;
            height: 35px;
        }

        /deep/.el-step.is-horizontal .el-step__line {
            top: 17px;
        }

        /deep/.el-step__head.is-process {
            color: #c0c4cc;
            border-color: #c0c4cc;
        }
    }

    .right_idcar {
        justify-content: space-around;

        .right_imgbox {
            width: 210px;
            height: 132px;

            img {
                width: 210px;
                height: 132px;
            }
        }

        /*  .hiddenInput {
                  display: none;
              }

              .hiddenInput2 {
                  display: none;
              }*/
    }

    .certiTop {
        align-items: center;
        font-size: 14px;

        .certiTop_name {
            align-items: center;
            margin-right: 30px;

            p {
                width: 56px;
                margin-right: 20px;
                text-align: justify;
            }

            input {
                border: none;
                background: #fafafa;
                border-radius: 5px;
                width: 135px;
                height: 40px;
                padding-left: 10px;
            }

            span {
                display: inline-block;
                width: 54px;
                height: 40px;
                margin-right: 20px;
                line-height: 40px;
                text-align: center;
                background: #fafafa;
                border-radius: 5px;
                cursor: pointer;
            }

            .span_active {
                background: #2d50a1;
                color: #fff;
            }
        }
    }

    .certiTop_ID {
        font-size: 14px;
        align-items: center;
        margin: 30px 0;

        p {
            width: 56px;
            margin-right: 20px;
            text-align: justify;
        }

        input {
            border: none;
            padding-left: 10px;
            background: #fafafa;
            border-radius: 5px;
            width: 368px;
            height: 40px;
        }
    }

    .certiTop_bottom {
        font-size: 14px;
        align-items: center;

        .certiTop_bottom1 {
            align-items: center;
            margin-right: 20px;
        }

        .certiTop_bottom2 {
            align-items: center;

            input {
                border: none;
                background: #fafafa;
                border-radius: 5px;
                width: 358px;
                height: 40px;
                padding-left: 10px;
            }
        }

        p {
            width: 56px;
            text-align: justify;
            margin-right: 20px;
        }

        input {
            border: none;
            background: #fafafa;
            border-radius: 5px;
            width: 234px;
            height: 40px;
            padding-left: 10px;
        }
    }

    .certibutton {
        text-align: center;
        margin-top: 50px;
        margin-bottom: 20px;

        button {
            cursor: pointer;
            min-width: 70px;
            height: 38px;
            background: #2d50a1;
            border-radius: 5px;
            color: #fff;
            line-height: 38px;
            border: none;
            padding: 0 10px;
        }
    }

    .certificationStatus {
        text-align: center;
        margin: 0 auto;
        width: 500px;
        padding: 20px 0 50px;

        img {
            margin-bottom: 15px;
        }

        .name {
            color: #333;
            font-size: 20px;
            padding-bottom: 10px;
        }

        .message {
            font-size: 14px;
            color: #555;

            span {
                font-weight: bold;
                color: #000;
            }
        }
    }
}

// 认证信息
.cardMess {
    border: 1px solid #efefef;
    border-radius: 5px;
    padding: 20px;
    margin: 0px 50px;

    h5 {
        font-size: 16px;
        margin-bottom: 20px;
    }

    .cardMess_box {
        display: flex;
        margin-bottom: 30px;

        .oitem_title {
            width: 90px;
            text-align: right;
            margin-right: 20px;
        }

        .box_oitem {
            display: flex;
            align-items: center;
            width: 50%;
        }

        .oitem_img {
            width: 80px;
            height: 50px;
            margin-right: 15px;
            position: relative;
            cursor: pointer;

            /deep/ .el-image {
                width: 100%;
                height: 100%;
            }

            &:hover .oitem_img_text {
                display: flex;
            }

            img {
                width: 100%;
                height: 100%;
            }

            .oitem_img_text {
                display: none;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                color: #fff;
                width: 100%;
                height: 20px;
                line-height: 20px;
                background: rgb(85 85 85 / 73%);
                position: absolute;
                bottom: -9px;

                i {
                    margin-right: 5px;
                }
            }
        }

        span {
            display: inline-block;
            width: 54px;
            height: 40px;
            margin-right: 20px;
            line-height: 40px;
            text-align: center;
            background: #fafafa;
            border-radius: 5px;
            cursor: pointer;
        }

        .span_active {
            background: #2d50a1;
            color: #fff;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/registeredLogin/certificationCenter/index.vue